/****************************************************
 * Module Name:  tradingcompanyProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class TradingcompanyProxy {
  static GetAllTradingcompany = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/tradingcompany",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllTradingcompanyMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/tradingcompany/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleTradingcompany = (tradingcompanyId, callback) => {
    let params = {
      id: tradingcompanyId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/tradingcompany",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckTradingcompanyAvailable = (tradingcompany, callback) => {
    let params = {
      tradingcompany: tradingcompany,
    };

    restAPICall(
      Constants.MANAGER_URL + "/tradingcompany/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddTradingcompany = (tradingcompany, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/tradingcompany",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(tradingcompany),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateTradingcompany = (tradingcompany, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/tradingcompany",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(tradingcompany),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteTradingcompany = (tradingcompany, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/tradingcompany",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(tradingcompany),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
